"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
var _reactRedux = require("react-redux");
var _phoneAuth = require("../../../../actions/phoneAuth");
var _selectors = require("./selectors");
var _ConfirmationCallCodeFormController = require("../../../../components/ConfirmationCallCodeFormController");
var _tracking = require("../../../../utils/tracking");
var _source = require("../../../../selectors/source");
function mapStateToProps(state) {
  return {
    isSubmitting: (0, _selectors.isPhoneAuthValidateFormSubmitting)(state),
    hasCodeError: (0, _selectors.hasRegisterOrAuthErrorSelector)(state),
    codeError: (0, _selectors.registerOrAuthErrorSelector)(state),
    codeTimeout: (0, _selectors.resendTimeoutSelector)(state),
    sendValidationCodeStatus: (0, _selectors.sendValidationCodeStatusSelector)(state),
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    onResendCode() {
      (0, _tracking.trackPhoneAuthResendCodeClick)();
      dispatch((0, _phoneAuth.sendCode)());
    },
    onVerify(code) {
      dispatch((0, _phoneAuth.registerOrAuthorize)({
        code
      }));
    },
    onCodeCleared() {
      (0, _tracking.trackPhoneAuthCallReEnterButtonClick)();
    }
  };
}
const FormContainer = exports.FormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ConfirmationCallCodeFormController.ConfirmationCallCodeFormController);